import { ReactNode, useState } from 'react';
import { Outlet } from 'react-router-dom';

import './Style.scss';
import { ObjectHeader } from '../../../shared/Components/ObjectHeader';
import { HeaderExtraContext } from '../../../shared/Components/HeaderExtraContext';
import { EntityDataUsuario } from '../../../shared/Domain/EntityDataUsuario';

interface ViewProps {
    auth: boolean;
    user: EntityDataUsuario;
    iconMenu: boolean;
    showSaludo: boolean;
    pageTitle: string;
    pageSubtitle: string;
    breadcrumbList: Array<{ text: string; navigate: boolean; path: string }>;
    online: boolean;
    countProcess: number;
    onClickHome: Function;
    onClickHelp: Function;
    onClickReport: Function;
    onClickProfile: Function;
    onClickVariable: Function;
    onClickLogout: Function;
    onHideIconMenu: Function;
    onShowIconMenu: Function;
};

export const ViewMain = (props: ViewProps) => {
    const isInternalPage = props.showSaludo && !!props.pageTitle;
    const [headerExtra, setHeaderExtra] = useState<ReactNode>(null);

    return (
        <>
            <ObjectHeader
                auth={props.auth}
                user={props.user}
                iconMenu={props.iconMenu}
                online={props.online}
                countProcess={props.countProcess}
                onHideIconMenu={props.onHideIconMenu}
                onShowIconMenu={props.onShowIconMenu}
                onClickHome={props.onClickHome}
                onClickHelp={props.onClickHelp}
                onClickReport={props.onClickReport}
                onClickProfile={props.onClickProfile}
                onClickVariable={props.onClickVariable}
                onClickLogout={props.onClickLogout}
                showSaludo={props.showSaludo}
                pageTitle={props.pageTitle}
                pageSubtitle={props.pageSubtitle}
                headerExtra={headerExtra}
                breadcrumbList={props.breadcrumbList}
            />
            <main className={!isInternalPage ? "ViewMasterMain" : 'ViewMasterMain-Internal'}>
                <HeaderExtraContext.Provider value={setHeaderExtra}>
                    <Outlet />
                </HeaderExtraContext.Provider>
            </main>
        </>
    )
};